{
  "summary": "Summary",
  "linkToArticle": "Link to Article",
  "title": "Title",
  "remove": "Remove",
  "imageOptional": "Image (optional)",
  "articleConfiguration": "Article Configuration",
  "status": "Status",
  "articleLink": "Article Link",
  "lastUpdated": "Last Updated",
  "uploadedBy": "Uploaded By",
  "articleName": "Article Name",
  "filter": "Filter",
  "state": "State",
  "clearFilter": "Clear filter",
  "applyFilter": "Apply filter",
  "active": "Active",
  "inactive": "Inactive",
  "draft": "Draft",
  "paginatedView": "View 1 - 3 of {{totalCount}}",
  "errorStateMessage": "Field can not be left empty",
  "errorUrlStateMessage": "Field has to be a valid Url",
  "cancel": "Cancel",
  "confirm": "Confirm",
  "deleteArticle": "Delete News Article",
  "deleteArticleMessage": "Are you sure you want to delete this news article? Once deleted, the content will be permanently erased and cannot be recovered.",
  "visibleToRoles": "Visible to roles",
  "visibleToRolesHelp": "Only users with these roles see this article. Leave empty to show it to all roles.",
  "visibleToRolesRemoveOnlyHelp": "Role targeting is turned off for this organization. You can remove roles but not add them.",
  "visibleTo": "Visible to",
  "allRoles": "All roles",
  "roleCount_one": "{{count}} role",
  "roleCount_other": "{{count}} roles",
  "showingAllRoles": "Preview includes articles for every role"
}
